import { Container } from "@mui/material"
import Header from "../components/shared/CustomPageHeader"
import McdoLogo from "../assets/imgs/logos/McdoLogo.svg"
import ManmaruLogo from "../assets/imgs/logos/ManmaruLogo.svg"
import LogoSample from "../assets/imgs/logos/LogoSample.svg"
import PrymeBookingLogo from "../assets/imgs/logos/PrymeBookingLogo-White.svg"

export default function CustomPageLayout({
  children,
  logo,
  store = "PrymeBookingLogo",
}) {
  const storeLogos = {
    mcdo: McdoLogo,
    manmaru: ManmaruLogo,
    sample: LogoSample,
    techpryme: PrymeBookingLogo,
  }

  const selectedLogo = logo || storeLogos[store] || McdoLogo

  return (
    <>
      <Header logo={selectedLogo} />
      <main>
        <Container disableGutters maxWidth={false}>
          {children}
        </Container>
      </main>
      {/* <Footer /> */}
    </>
  )
}
